export default [
    {
        path: '/hourGroups',
        name: 'hour-groups',
        component: () => import ('./views/HourGroupIndex'),
        meta: {
            title: 'Grupo de horários',
            icon: 'mdi-briefcase-clock',
            breadcrumbs: [
                { text: 'Lista os grupos de horários disponíveis', disabled: true }
            ]
        }
    },
]